<template>
  <div>
    <!-- <sort-dialog v-model="showSortDialog"/> -->

    <div v-if="loading" class="text-xs-center my-5 pt-5">
      <v-progress-circular :size="50" color="black" indeterminate />
    </div>

    <div v-else>
      <v-layout row>
        <v-flex>
          <h1>{{ $tc('COMMON.SALE', 2) }}</h1>
        </v-flex>
        <v-flex text-xs-right></v-flex>
      </v-layout>

      <masonry :cols="{default: 3, 1200: 2, 960: 1}" :gutter="40">
        <tk-artwork v-for="artwork in artworks" :key="artwork.id" class="mb-4" :artwork="artwork">
          <template v-slot:action-btns>
            <v-divider />
            <v-card-actions class="pa-0">
              <tk-btn
                block
                :loading="artwork.cloning"
                flat
                @click="clone(artwork)"
              >{{ $t('ACCOUNT.CLONE') }}</tk-btn>
            </v-card-actions>
          </template>
        </tk-artwork>
      </masonry>

      <div class="text-xs-right mt-4" v-if="artworks.length">
        <v-pagination
          @input="fetchData"
          :disabled="loading"
          :value="pagination.currentPage"
          :length="pagination.lastPage"
          :total-visible="7"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "@/services/RepositoryFactory";
import { ErrorHandler } from "@/utils/ErrorHandler";

const artworksRepo = RepositoryFactory.artworks();
const handler = new ErrorHandler();

export default {
  components: {
    // SortDialog: () => import("./SortDialog")
  },
  data() {
    return {
      showSortDialog: false,
      artworks: [],
      pagination: {},
      loading: true,
    };
  },

  created() {
    this.fetchData(1);
  },

  methods: {
    async fetchData(page) {
      this.loading = true;
      await handler.handle(async () => {
        const res = await artworksRepo.profileSoldArtworks(page);
        this.artworks = res.data;
        this.pagination = res.pagination;
      });
      this.loading = false;
    },

    async clone(artwork) {
      artwork.cloning = true;

      await handler.handle(async () => {
        const res = await artworksRepo.cloneArtwork(artwork.id);
        console.log({ res });
        await this.$auth.refresh();

        this.$router.push({
          name: "profile.artworks.edit",
          params: { artworkId: res.id },
        });
      });

      artwork.cloning = false;
    },
  },
};
</script>
